export default "__VITE_ASSET__ee760976__"